export type QueueState = { remaining: number[]; roundIds?: number[]; lastDrawnId?: number };

export function shuffled(ids: number[], random: () => number = Math.random) {
  const next = [...ids];
  for (let index = next.length - 1; index > 0; index -= 1) {
    const swap = Math.floor(random() * (index + 1));
    [next[index], next[swap]] = [next[swap], next[index]];
  }
  return next;
}

export function reconcileQueue(state: QueueState | null, eligibleIds: number[], random: () => number = Math.random): QueueState {
  const eligible = [...new Set(eligibleIds)];
  const allowed = new Set(eligible);
  const remaining = (state?.remaining || []).filter((id) => allowed.has(id));
  const roundIds = (state?.roundIds || state?.remaining || []).filter((id) => allowed.has(id));
  const additions = eligible.filter((id) => !roundIds.includes(id));
  return { remaining: [...remaining, ...shuffled(additions, random)], roundIds: [...roundIds, ...additions], lastDrawnId: state?.lastDrawnId };
}

export function drawNext(state: QueueState | null, eligibleIds: number[], random: () => number = Math.random): { id?: number; state: QueueState } {
  const eligible = [...new Set(eligibleIds)];
  if (!eligible.length) return { state: { remaining: [], roundIds: [], lastDrawnId: state?.lastDrawnId } };
  let next = reconcileQueue(state, eligible, random);
  if (!next.remaining.length) next = { ...next, remaining: shuffled(eligible, random), roundIds: eligible };
  if (eligible.length > 1 && next.remaining.length === eligible.length && next.remaining[0] === next.lastDrawnId) {
    const alternate = next.remaining.findIndex((id) => id !== next.lastDrawnId);
    [next.remaining[0], next.remaining[alternate]] = [next.remaining[alternate], next.remaining[0]];
  }
  const id = next.remaining[0];
  return { id, state: { remaining: next.remaining.slice(1), lastDrawnId: id } };
}

export function resetRound(eligibleIds: number[], random: () => number = Math.random): QueueState {
  const roundIds = [...new Set(eligibleIds)];
  return { remaining: shuffled(roundIds, random), roundIds };
}

export function queueStorageKey(accountScope: string, classId: number) {
  return `elume:random-name-queue:v1:${accountScope}:class:${classId}`;
}
